export const languagesettings = {
  'languagesettings.title': 'Language settings',
  'languagesettings.titleLanguage': 'LANGUAGE',
  'languagesettings.descriptionLanguage':
    'Let us know which language you want to use on Preferenca. You can change it back at any time.',
  'languagesettings.titleContentLanguage': 'CONTENT LANGUAGE',
  'languagesettings.descriptionContentLanguage':
    "Select the language you want content on Preferenca translated into. We'll show options to translate content such as descriptions and other user content to this language and use this information to improve your overall Preferenca experience.",
}
